import { InjectionToken } from '@angular/core';
import type { ErrorLogConfig } from './error-log.config';

export const ErrorLogConfigToken = new InjectionToken<ErrorLogConfig>('[Error log] config');
